<template>
  <b-col md="12">
    <section class="conditions">
      <p class="conditions__title">Condizioni per i bambini e letti supplementari</p>
      <div class="conditions__wrap">
        <div class="conditions__item">
          <p class="conditions__item-title semibold">Condizioni per culle e letti aggiuntivi</p>
          <ul class="conditions__item-list mb-0">
            <li class="conditions__item-li">Le richieste sono soggette a disponibilità</li>
            <li class="conditions__item-li">
              Le richieste devono essere confermate, <span class=semibold>contatta la struttura</span>
            </li>
            <li class="conditions__item-li">Le richieste potrebbero comportare costi extra</li>
          </ul>
        </div>
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  name: 'conditions',

  components: {
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .conditions {
    margin-top: $grid-gutter-width * 2;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 20px;
    }

    &__wrap {
      padding: 15px 20px;
      border: 1px solid $gray-300;
      background-color: #fafcff;
      border-radius: 10px;
    }

    &__item {
      &_title {
        margin-bottom: 10px;
      }
    }

    @media print {
      display: none;
    }
  }

</style>